import type { AskReport, ReportTopic } from './types';

/** Old reports remain readable without rewriting their stored source titles. */
export function topicTitle(topic: { name: string; displayName?: string; teacherTitle?: string }): string {
  const sourceTitle = readableSource(topic.name);
  const scopes = sourceTitle.split(/\s+(?:and|or|[-–—])\s+/i);
  if (topic.teacherTitle?.trim()) {
    // Do not let a request-focused title erase half of a compound catalog topic.
    const titleWords = new Set(topic.teacherTitle.toLowerCase().match(/[a-z0-9]+/g) ?? []);
    const scopeWords = scopes.flatMap(scope => scope.toLowerCase().match(/[a-z0-9]+/g) ?? []).filter(word => !['for', 'with', 'the', 'of', 'in', 'to', 'and', 'or'].includes(word));
    if (scopes.length > 1 && scopeWords.some(word => !titleWords.has(word))) return sourceTitle;
    return topic.teacherTitle.trim();
  }
  return readableSource(topic.displayName?.trim() || topic.name.trim());
}
function readableSource(source: string): string {
  const clean = source.replace(/^(?:M|S|ELA|SS)\.\s*(?=[A-Z][a-z])/, '') || source;
  return clean
    .replace(/^Operations with (.+?)\s*[-–—]\s*Multiplication and Division$/i, 'Multiplying and Dividing $1')
    .replace(/^Operations with (.+?)\s*[-–—]\s*Addition and Subtraction$/i, 'Adding and Subtracting $1')
    .replace(/^Teaching\s*[-–—]\s*/i, 'Teaching ');
}

export function reportTopics(report: AskReport) {
  const topics = new Map<string, { topic: ReportTopic; standards: { id: string; code: string; reason: string }[] }>();
  for (const topic of report.topics ?? []) topics.set(topic.id, { topic, standards: [] });
  for (const standard of report.standards) for (const topic of standard.topics) {
    let entry = topics.get(topic.id);
    if (!entry) { entry = { topic, standards: [] }; topics.set(topic.id, entry); }
    if (!entry.standards.some(s => s.id === standard.id)) entry.standards.push({ id: standard.id, code: standard.statementCode, reason: topic.reason });
  }
  return [...topics.values()];
}

export function allReportTopics(report: AskReport): ReportTopic[] {
  return [...reportTopics(report).map(entry => entry.topic), ...(report.teachingTopics ?? [])];
}
